import { FormsKeys as n } from "../i18n/translations/types/forms.js";
var f = (e, t, i) => {
  const { required: s } = i || {};
  return s && !`${t || ""}`.trim() ? {
    msg: e(n.Defaults_Messages_RequiredField),
    msgKey: n.Defaults_Messages_RequiredField
  } : !0;
}, m = (e) => {
  if (e == null) return "";
  if (typeof e == "string") return e;
  if (typeof e == "object") {
    if ("msg" in e && e.msg) return e.msg;
    if ("msgKey" in e && e.msgKey) return e.msgKey;
  }
  return "";
}, g = ({ t: e, validator: t, value: i, extraProps: s = {} }) => {
  let u = f(e, i, s);
  return u === !0 && t && (u = t(i, s)), {
    isValid: u === !0,
    error: m(u)
  };
};
export {
  g as handleValidation,
  m as mapErrorToString
};

//# sourceMappingURL=validation.helper.js.map